export const signalrConfig = {
  Hubs: [
    {
      ServerUrl: `${process.env.REACT_APP_MARKET_SIGNALR_ENDPOINT}/signal`,
      Prefix: 'Realtime',
      RegisteredRemoteChannels: [],
    },
  ],
}

export const channelConfig = {
  UserLogin: 'Realtime.UserLogin',
  UserNotification: 'Realtime.UserNotification',
  UserAlert: 'Realtime.UserAlert',
}
